'use client';

import { useEffect, useState, useCallback } from 'react';
import useGlobalState from '@hooks/useGlobalState';
import { BrazeManager } from '@utils/brazeManager';

interface BrazePageViewProps {
  eventName: string;
  eventParam?: Record<string, any>;
}

export function BrazeLog<T>({
  eventName,
  eventParam = {},
}: BrazePageViewProps) {
  const { appInfo } = useGlobalState<T>();
  const [isMounted, setIsMounted] = useState(false);

  const init = useCallback(async () => {
    BrazeManager.logEvent({
      isNativeAppBoth: appInfo.isNativeAppBoth,
      isIOS: appInfo.isIos,
      eventName,
      properties: eventParam,
    });
  }, [appInfo.isNativeAppBoth, appInfo.isIos, eventName, eventParam]);

  useEffect(() => {
    if (isMounted) {
      init();
    }
  }, [isMounted, init]);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return null;
}
